export function parseOptionalAmount(value: unknown): number | undefined {
  if (value === null || value === undefined) return undefined;
  const normalized = String(value).trim();
  return normalized === '' ? undefined : Number(normalized);
}

export function isValidAmount(value: number | undefined): boolean {
  return value === undefined || (Number.isFinite(value) && value >= 0 && value <= 1_000_000);
}
